import { ReactNode, useEffect } from 'react';
import { Container, Box, Link } from '@chakra-ui/react';
import { UniLogo } from './uniLogo';
import { SpinnerModal } from '../../molecules/SpinnerModal';

interface IProps {
  children: ReactNode;
  isLoading?: boolean;
  isAuthPage?: boolean;
  assetsUrl?: string;
  isStudentApp?: boolean;
  isInitialLoad?: boolean;
}

function PageWrapper({ children, isLoading, isInitialLoad, isAuthPage, assetsUrl, isStudentApp }: IProps) {
  useEffect(() => {
    if (isStudentApp) {
      document.body.classList.add('body-login-student');

      return () => {
        document.body.classList.remove('body-login-student');
      };
    }
    document.body.classList.add('body-login');

    return () => {
      document.body.classList.remove('body-login');
    };
  }, [isStudentApp]);

  return (
    <>
      <SpinnerModal show={!!isLoading} />

      <Container maxW={isAuthPage ? '2xl' : 'lg'} pt={{ base: 8, sm: 16 }} pb={12}>
        <Link href="/" display="flex" justifyContent="center" mb={{ base: 8, sm: 12 }}>
          <UniLogo assetsUrl={assetsUrl} isStudentApp={isStudentApp} />
        </Link>

        {isInitialLoad ? null : (
          <Box
            as="main"
            data-selector="content-wrap"
            bgColor="chakra-body-bg"
            color="chakra-body-text"
            borderRadius="3xl"
            px={{ base: 6, sm: 14 }}
            py={{ base: 8, sm: 12 }}
          >
            {children}
          </Box>
        )}
      </Container>
    </>
  );
}

export default PageWrapper;
